import moment from "moment";
import React from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";

type Props = {
  columns: columnTypes[];
  rows: any[];
  setRowId:any ;
  studentAttendanceCount: any;
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const BatchStudentAttendanceListing = ({
  columns,
  rows,
  studentAttendanceCount,
  setRowId ,
  paginationProps: { isTableLoading, searchValue, setSearchValue },
}: Props) => {
  return (
    <div className="flex flex-col h-full m-4">
      <div className="flex flex-col ml-3 mb-2">
        <span className="text-sm font-medium">
          Total Student :{studentAttendanceCount?.totalStudentCount || 0}{" "}
        </span>
        <div className="flex gap-4">
          <span className="text-sm font-medium text-green-700">
            Present : {studentAttendanceCount?.totalPresent || 0}{" "}
          </span>
          <span className="text-sm font-medium text-red-700">
            Absent : {studentAttendanceCount?.totalAbsent || 0}{" "}
          </span>
        </div>
        <div className="flex gap-4">
          <span className="text-sm font-medium text-lime-600">
            OnTime : {studentAttendanceCount?.totalOnTime || 0}
          </span>
          <span className="text-sm font-medium text-amber-600	">
            Late : {studentAttendanceCount?.totalNotOnTime || 0}{" "}
          </span>
        </div>
      </div>
      {/* Page Header */}
      <div className="pb-3">
        <ATMPageHeader
          hideAddButton
          pageTitle={moment().format("DD MMM yyyy")}
          searchValue={searchValue}
          onSearchChange={setSearchValue}
        />
      </div>

      {/* Table */}
      <div className="flex-1 overflow-auto flex flex-col">
        <ATMTable
          isLoading={isTableLoading}
          onRowClick={(row)=>{setRowId(row?._id)}}
          columns={columns}
          rows={rows}
          rowExtraClasses={() => "min-h-[40px]"}
        />
      </div>
    </div>
  );
};

export default BatchStudentAttendanceListing;
